import deepClone from 'clone-deep'

export default deepClone
